// src/components/store/sections/gallery/GalleryV66HexagoncombRoyalViolet.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV66HexagoncombRoyalViolet(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={66}
      archKey="hexagon_comb"
      archLabel="Hexagon Honeycomb Frames"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
